export default {
    id: null,
    descricao: null,
    tipo: null,
    parent: null,
    dre: null,
    materiaPrima: null,
}
